export default __webpack_public_path__ + "static/media/127.ed346ef2.webp";